<mat-progress-bar class="session-bar" matTooltip="{{'key_session_left' | translate}}" *ngIf="hasClaims && sessionTimeLeft" color="warn" mode="determinate" [value]="progressValue"></mat-progress-bar>
<span *ngIf="sessionTimeLeft" class="minutes-left">{{this.sessionTimeLeft / 60 | number: '1.0-0'}} {{'key_session_left' | translate}}</span>
<router-outlet></router-outlet>
